/**
 * Global Functionality
 * The logic in this is intended to ONLY contain any functionality
 * that is required on every page load.
 *
 * NOTE: Please do not include any page-specific logic here.
 **/

require('./GD-Analytics.js');
require('./GD-Engagement.js');
require('./SwipeSensor001.js');
require('./shims/requestAnimFrame.js');
require('./polyfills/NodeList.prototype.forEach.js');

const globalNavMobileTabletDesktop = require('../services/global-nav-mobile-tablet-desktop');

const FB = require('../services/facebook-sdk');
FB();

const Twitter = require('../services/twitter-sdk');
Twitter();

import Logger from "./logger";


export default function () {
  const NAME = 'Global';
  Logger.info(`${NAME} > loading`);

  // Vars
  // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
  const getUrl = window.location.href;
  const getAction = getUrl.split('#');
  const getSlugSection = getAction[1];

	window.app = {
		global : {
			vars : {}
		},
		services : {}
	};


  // Logic
  // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

  if (getSlugSection){
    document.addEventListener('DOMContentLoaded', (e)=> {
      e.preventDefault();
      const getItemHash = document.querySelector(`#${getSlugSection}`);
      if (!getItemHash) return;
      getItemHash.scrollIntoView(true);
    })
  }

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        if (!document.querySelector(this.getAttribute('href'))) return;
        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});


  /**
   * init --- Initialization block
   */
  function init() {
    Logger.info(`${NAME} > init`);
    globalNavMobileTabletDesktop();
  }

  // Do not edit below this line...
  // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
  Logger.info(`${NAME} > loaded`);

  init();
}
